// Intentionally simple format check (one @, no whitespace, a dotted domain).
// The address usually comes straight from an Outlook recipient, so this only has
// to catch hand-edited typos — full RFC validation is not the goal.
// Domain labels exclude the dot so the pattern matches in linear time — no
// backtracking between the label and the literal dot (Sonar S8786).
const EMAIL_PATTERN = /^[^\s@]+@[^\s@.]+(\.[^\s@.]+)+$/

export function isValidEmail(value: string): boolean {
  return EMAIL_PATTERN.test(value.trim())
}
